export default {
  h1: `
    font-family: 'Taviraj-ExtraLight', serif;
    font-size: 11rem;
    line-height: 1.6;
    font-weight: 200;
  `,
  h2: `
    font-family: 'Taviraj-ExtraLight', serif;
    font-size: 7rem;
    line-height: 1.6;
    font-weight: 200;
  `,
  h3: `
    font-family: 'Taviraj-ExtraLight', serif;
    font-size: 6rem;
    font-weight: 200;
    line-height: 1.4;
  `,
  h4: `
    font-family: 'Taviraj-Light', serif;
    font-size: 3.2rem;
    line-height: 1.4;
  `,
  h5: `
    font-family: 'Nexa Bold', sans-serif;
    font-size: 1.7rem;
    font-weight: bold;
    line-height: 1.6;
    text-transform: uppercase;
  `,
  h6: `
    font-family: 'Nexa Bold', sans-serif;
    font-size: 1.4rem;
    line-height: 1.6;
  `,
  h7: `
    font-family: 'Nexa Regular', sans-serif;
    font-size: 1.4rem;
    line-height: 1.6;
  `,
  big: `
    font-size: 4.6rem;
    line-height: 5rem;
    letter-spacing: 0.08rem;
  `,
  sub: `
    font-size: 3.6rem;
    line-height: 4rem;
    letter-spacing: 0.08rem;
  `,
  menuLink: `
  font-size: 9.6rem;
  line-height: 9.6rem;
  letter-spacing: 0.08rem;
`,
  navbarLink: `
  font-size: 1.8rem;
  line-height: 2.7rem;
  `,
  headerSmall: `
    font-size: 2.8rem;
    line-height: 3.2rem;
    letter-spacing: 0.07rem;
  `,
  title: `
    font-size: 2rem;
    line-height: 2.4rem;
    letter-spacing: 0.06rem;
  `,
  text: `
    font-size: 1.75rem;
    line-height: 2.2rem;
    letter-spacing: 0.04rem;
  `,
  small: `
    font-size: 1.6rem;
    line-height: 1.8rem;
    letter-spacing: 0.03rem;
  `,
  t2: `
    font-family: 'Taviraj-Light', serif;
    font-size: 2.4rem;
    line-height: 1.6;
    letter-spacing: 0.03rem;
  `,
  regular16: `
    font-family: 'Nexa Regular', sans-serif;
    font-size: 1.6rem;
    line-height: 1.6;
  `,
}
